import styled from 'styled-components';

import { GridContainer } from '@xing-com/grid';
import { SkeletonBody, SkeletonImage } from '@xing-com/skeleton';
import { scale000, scale220, spaceL, spaceM, spaceS } from '@xing-com/tokens';

const StyledGridContainer = styled(GridContainer)`
  margin-bottom: ${scale220};
`;

const ArticleHeaderSkeleton = styled.div`
  display: flex;
  align-items: center;
  padding: ${spaceL} ${spaceL} ${spaceM};
`;

const StyledSkeletonBodyCopy = styled(SkeletonBody)`
  flex: 1;
  margin-left: ${spaceS};

  & > div {
    margin-bottom: ${scale000};
  }
`;

const StyledSkeletonImage = styled(SkeletonImage)`
  aspect-ratio: 16/9;
`;
const ArticleFooter = styled.div`
  padding: ${spaceL} ${spaceL} ${spaceS};
`;

export const Styled = {
  GridContainer: StyledGridContainer,
  ArticleHeaderSkeleton,
  SkeletonBodyCopy: StyledSkeletonBodyCopy,
  SkeletonImage: StyledSkeletonImage,
  ArticleFooter,
};
